/**
 * Parses input with unit
 */
export default function parseUnit(input: string | number | undefined = '', unit = 'px') {
    if (typeof input === 'number') {
        return input
    }

    if (typeof input === 'string') {
        if (input.replace(unit, '').match(/^\d+$/g)) {
            return Number.parseInt(input, 10)
        }
    }
}
